<influencer-module-container [title]="('INFLUENCER.insight.top_exposure.title' | translate) | titlecase" 
	[hasNoData]="hasNoData"
	[isFetchingData]="isFetchingData" 
	[placeholderWidth]="361" 
	[printMode]="printMode">

	<div class="top-exposures-container" [class.print-mode]="printMode">
		<div class="row top-exposures-row">
			<ng-container *ngIf="!hasNoData && !isFetchingData">
				<div class="col-4 top-exposures-col" *ngFor="let topExposure of topExposures; let i = index;">
					<influencer-top-exposure-item [platformList]="platformList" 
						[exposureType]="getExposureType(i)" 
						[topExposure]="topExposure"
						[printMode]="printMode">
					</influencer-top-exposure-item>
				</div>
			</ng-container>

			<ng-container *ngIf="hasNoData || isFetchingData">
				<div class="col-4 top-exposures-col">
					<influencer-top-exposure-item-placeholder [name]="'INFLUENCER.insight.top_exposure.reach' | translate" [printMode]="printMode">
					</influencer-top-exposure-item-placeholder>
				</div>

				<div class="col-4 top-exposures-col">
					<influencer-top-exposure-item-placeholder [name]="'INFLUENCER.insight.top_exposure.engagement' | translate" [printMode]="printMode">
					</influencer-top-exposure-item-placeholder>
				</div>

				<div class="col-4 top-exposures-col">
					<influencer-top-exposure-item-placeholder [name]="'INFLUENCER.insight.top_exposure.impact' | translate" [printMode]="printMode">
					</influencer-top-exposure-item-placeholder>
				</div>
			</ng-container>
		</div>
	</div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposures.component.html